<template>
  <div v-if="readonly" class="form-control" disabled readonly tabindex="0">
    <employee-display :employee="value" :show-email="showEmail" />
  </div>
  <v-select
    v-else
    v-bind="{
      placeholder,
      multiple,
      taggable,
      disabled,
      clearable,
      reduce,
      value,
      options,
      createOption
    }"
    :options="computedOptions"
    label="emailAddress"
    :filter-by="filterEmployee"
    select-on-tab
    :clear-search-on-blur="() => true"
    style="width: 1%"
    @search="searchText = $event"
    @input="$emit('input', $event)"
  >
    <template #selected-option="employee">
      <employee-display :employee="employee" :show-email="showEmail" />
    </template>

    <template #option="item">
      <div class="d-flex">
        <employee-display :employee="item" :show-email="showEmail" class="flex-grow-1" />
        <em v-if="item.type != 'EMPLOYEE'" class="mr-2">{{ item.type }}</em>
      </div>
    </template>
    <template #no-options="{ searching }">
      {{ !searching && noOptionsText != null ? noOptionsText : 'No results found.' }}
    </template>

    <template v-if="taggable" #list-footer>
      <li class="text-center">Click enter to add.</li>
    </template>
  </v-select>
</template>
<script>
import vSelect from 'vue-select';
import EmployeeDisplayComponent from '@/shared/components/ui/EmployeeDisplayComponent';

import { mapGetters } from 'vuex';
import { LookupGetters } from '@/shared/store/lookup/types';
import { CustomerGetters } from '@/shared/store/customer/types';
export default {
  name: 'EmployeeSelect',
  components: {
    vSelect,
    'employee-display': EmployeeDisplayComponent
  },
  props: {
    readonly: {
      type: Boolean,
      default: false,
      searchText: ''
    },
    value: {
      type: [Array, Object, String, Number],
      default: () => {
        return null;
      }
    },
    options: {
      type: Array,
      default() {
        return this.isNoGroupRecipients ? this.filteredEmployeesList : this.employeeList;
      }
    },
    noOptionsText: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    showEmail: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    multiple: Boolean,
    taggable: Boolean,
    clearable: Boolean,
    reduce: {
      type: Function,
      default: option => option
    },
    createOption: {
      type: Function,
      default: email => ({ emailAddress: email })
    },
    isNoGroupRecipients: {
      type: Boolean,
      default: false
    },
    allowCustomerSearch: {
      type: Boolean,
      default: false
    },
    searchInOptions: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      employees: [],
      searchText: ''
    };
  },
  computed: {
    ...mapGetters({
      employeeList: LookupGetters.GET_EMPLOYEE_LIST,
      customerList: CustomerGetters.GET_CUSTOMER_ACTIVE_CONTACTS_LIST,
      vcpUserList: CustomerGetters.GET_VCP_USER_LIST
    }),
    filteredEmployeesList() {
      return this.employeeList.filter(emp => !emp.employeeId.startsWith('#CPS'));
    },
    computedOptions() {
      if (!this.searchText) {
        return this.options;
      }
      if (this.searchInOptions) {
        return this.options;
      }
      const employeeEmails = new Set(this.employeeList.map(emp => emp.emailAddress));
      return [
        ...this.employeeList,
        ...(this.allowCustomerSearch ? this.customerList.filter(cust => !employeeEmails.has(cust.emailAddress)) : []),
        ...(this.allowCustomerSearch ? this.vcpUserList.filter(cust => !employeeEmails.has(cust.emailAddress)) : [])
      ];
    }
  },
  methods: {
    filterEmployee(option, label, search) {
      return (
        (option.employeeId && option.employeeId.toLowerCase().indexOf(search.toLowerCase()) > -1) ||
        (option.emailAddress && option.emailAddress.toLowerCase().indexOf(search.toLowerCase()) > -1) ||
        (option.name && option.name.toLowerCase().indexOf(search.toLowerCase()) > -1) ||
        (option.firstName && option.firstName.toLowerCase().indexOf(search.toLowerCase()) > -1) ||
        (option.lastName && option.lastName.toLowerCase().indexOf(search.toLowerCase()) > -1)
      );
    }
  }
};
</script>
